export enum AvailableProviders {
  ABLocal = 'ABLocal',
  Acompio = 'Acompio',
  Alexa = 'Alexa',
  AllMenus = 'AllMenus',
  AmericanExpress = 'AmericanExpress',
  AmericanTowns = 'AmericanTowns',
  Apple = 'Apple',
  AroundMe = 'AroundMe',
  BetterBusinessBureau = 'BetterBusinessBureau',
  Bing = 'Bing',
  Brave = 'Brave',
  Brownbook = 'Brownbook',
  BrunchLunchDinner = 'BrunchLunchDinner',
  CentralIndex = 'CentralIndex',
  ChamberOfCommerce = 'ChamberOfCommerce',
  Citysearch = 'Citysearch',
  CitySquares = 'CitySquares',
  Cylex = 'Cylex',
  Doordash = 'Doordash',
  DunAndBradstreet = 'DunAndBradstreet',
  EightCoupons = 'EightCoupons',
  eLocal = 'eLocal',
  EzCater = 'EzCater',
  EZlocal = 'EZlocal',
  Facebook = 'Facebook',
  Foursquare = 'Foursquare',
  GoLocal247 = 'GoLocal247',
  Google = 'Google',
  Grubhub = 'Grubhub',
  Help = 'Help',
  Here = 'Here',
  HostMe = 'HostMe',
  HotFrog = 'HotFrog',
  HoursCom = 'HoursCom',
  iBegin = 'iBegin',
  iGlobal = 'iGlobal',
  Infobel = 'Infobel',
  InfoIsInfo = 'InfoIsInfo',
  InsiderPages = 'InsiderPages',
  Instacart = 'Instacart',
  InYourArea = 'InYourArea',
  Koomio = 'Koomio',
  Local = 'Local',
  LocalDatabase = 'LocalDatabase',
  LocalStack = 'LocalStack',
  Mapbox = 'Mapbox',
  Marqii = 'Marqii',
  MapQuest = 'MapQuest',
  Mapstr = 'Mapstr',
  Menupix = 'Menupix',
  MerchantCircle = 'MerchantCircle',
  MoneyMailer = 'MoneyMailer',
  MyLocalServices = 'MyLocalServices',
  N49 = 'N49',
  Navmii = 'Navmii',
  Nextdoor = 'Nextdoor',
  Oeffnungszeitenbuch = 'Oeffnungszeitenbuch',
  OneNineTwo = 'OneNineTwo',
  OpenAI = 'OpenAI',
  Opendi = 'Opendi',
  OpenTable = 'OpenTable',
  Ourbis = 'Ourbis',
  Pages24 = 'Pages24',
  PitneyBowes = 'PitneyBowes',
  ProfileCanada = 'ProfileCanada',
  PropertyCapsule = 'PropertyCapsule',
  QuinceaneraCom = 'QuinceaneraCom',
  RexDirect = 'RexDirect',
  SafeGraph = 'SafeGraph',
  SeccionAmarilla = 'SeccionAmarilla',
  ShowMeLocal = 'ShowMeLocal',
  Snapchat = 'Snapchat',
  Soleo = 'Soleo',
  SquareProduction = 'SquareProduction',
  Stadtbranchenbuch = 'Stadtbranchenbuch',
  Tellows = 'Tellows',
  TikTok = 'TikTok',
  TomTom = 'TomTom',
  TopRatedLocal = 'TopRatedLocal',
  TripAdvisor = 'TripAdvisor',
  Tupalo = 'Tupalo',
  TwoFindLocal = 'TwoFindLocal',
  Uber = 'Uber',
  UberEats = 'UberEats',
  USCity = 'USCity',
  WhereTo = 'WhereTo',
  Winnie = 'Winnie',
  wogibtswas = 'wogibtswas',
  Yahoo = 'Yahoo',
  Yalwa = 'Yalwa',
  Yandex = 'Yandex',
  YaSabe = 'YaSabe',
  Yell = 'Yell',
  YellowMoxie = 'YellowMoxie',
  YellowPageCity = 'YellowPageCity',
  YellowPages = 'YellowPages',
  YellowPagesCanada = 'YellowPagesCanada',
  YellowPagesDirectory = 'YellowPagesDirectory',
  Yelp = 'Yelp',
  ZipLocalOnline = 'ZipLocalOnline',
}
